import { render, staticRenderFns } from "./KpiWidget.vue?vue&type=template&id=21f277cd&scoped=true"
import script from "./KpiWidget.vue?vue&type=script&lang=js"
export * from "./KpiWidget.vue?vue&type=script&lang=js"
import style0 from "./KpiWidget.vue?vue&type=style&index=0&id=21f277cd&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21f277cd",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';
installComponents(component, {VIcon,VProgressCircular,VProgressLinear})
